<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png" />
    <HelloWorld msg="Welcome to Your Vue.js App" /> -->
    <PeriodicTable />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import PeriodicTable from "@/components/PeriodicTable.vue";

export default {
  name: "home",
  components: {
    HelloWorld,
    PeriodicTable
  }
};
</script>
